import React, { Component } from "react";
import { Table, Row, Col } from "reactstrap";
// import './test.css';
import ColorComponent from "./SvgColorOverview";
import { priceDisplay } from "../../../Constants/CommonConstant";
import ProviderUtils from "../../CommonComponent/ProviderUtils";

class ResizeGaiRecommendationTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.iconData,
      isAsp:
        this.props.isAsp !== null && this.props.isAsp !== undefined
          ? this.props.isAsp
          : false,
      hostOnly: ProviderUtils.hostOnly(
        this.props.providerName,
        this.props.data.metricsPlatform
      ),
      entityType:
        this.props.entityType !== undefined ? this.props.entityType : "vm",
      providerName: this.props.data.providerName,
      typeId: this.props.typeID,
    };
  }
  render() {
    const { data } = this.props;
    let dataDiskRecLength = 1;
    Object.keys(data.dataDisk).map((key) => {
      dataDiskRecLength += data.dataDisk[key].length;
    });
    return (
      <div>
        <Row id={`optimizationAnalysisGAIImg${this.state.typeId}`}>
          <div className="maindivCollapse" style={{ display: "flex" }}>
            <ColorComponent
              data={this.state.data[0].cpu}
              isResize={this.props.isResize}
              isLine={this.props.isLine}
              isAsp={this.state.isAsp}
              entityType={this.state.entityType}
              showCostPerfMarker={true}
              fromOverview={true}
            >
              {" "}
            </ColorComponent>
            {this.state.entityType === "db" ? (
              <ColorComponent
                data={this.state.data[0].disks}
                isResize={this.props.isResize}
                isLine={this.props.isLine}
                isAsp={this.state.isAsp}
                entityType={this.state.entityType}
                fromOverview={true}
              ></ColorComponent>
            ) : null}
            <ColorComponent
              data={this.state.data[0].memory}
              isResize={this.props.isResize}
              isLine={this.props.isLine}
              isAsp={this.state.isAsp}
              hostOnly={this.state.hostOnly}
              entityType={this.state.entityType}
              fromOverview={true}
            ></ColorComponent>
            <ColorComponent
              data={this.state.data[0].network}
              isResize={this.props.isResize}
              isLine={
                this.state.entityType === "db" ? false : this.props.isLine
              }
              isAsp={this.state.isAsp}
              entityType={this.state.entityType}
              fromOverview={true}
            ></ColorComponent>
            {this.state.entityType !== "db" ? (
              <ColorComponent
                data={this.state.data[0].disks}
                isResize={this.props.isResize}
                isLine={false}
                isAsp={this.state.isAsp}
                entityType={this.state.entityType}
                fromOverview={true}
              ></ColorComponent>
            ) : null}
          </div>
        </Row>
        <div className="panel" style={{ marginTop: "20px" }}>
          <Row>
            <Col id="ToPDF">
              <Table
                className="tableview "
                id={`recommendationObjectiveGAI${this.state.typeId}`}
                bordered
              >
                <thead>
                  <tr>
                    <td style={{ borderTop: "0px", borderLeft: "0px" }}></td>
                    <th>Original Spec</th>
                    <th>GAI Recommended Spec</th>
                    <th colSpan="2">Original Limits</th>
                    <th>GAI Recommended Limits</th>
                    <th>Original Cost*</th>
                    <th>GAI Recommended Cost*</th>
                  </tr>
                </thead>
                <tbody>
                  {data.vm.map((key, i) => {
                    return (
                      <tr>
                        {i === 0 ? (
                          <td rowSpan={data.vm.length}>
                            <div
                              className={
                                this.state.entityType === "db"
                                  ? "DbCpuClass"
                                  : "CpuClass"
                              }
                            >
                              {" "}
                            </div>
                            <Col className="tableLeftHead">
                              {this.state.entityType === "db" ? "vCORE" : "CPU"}
                            </Col>
                          </td>
                        ) : (
                          ""
                        )}
                        {i === 0 ? (
                          <td
                            className="textfield"
                            rowSpan={
                              data.vm.length *
                              (this.state.isAsp ||
                              this.state.entityType === "db"
                                ? 4
                                : 3)
                            }
                          >
                            {key.current_vmsize_name}
                            {key.hypervgeneration
                              ? " (" + key.hypervgeneration + ")"
                              : null}
                          </td>
                        ) : (
                          ""
                        )}
                        {i === 0 ? (
                          <td
                            className="textfield"
                            rowSpan={
                              data.vm.length *
                              (this.state.isAsp ||
                              this.state.entityType === "db"
                                ? 4
                                : 3)
                            }
                          >
                            {key.recommended_vmsize_name}
                            {key.resize_hypervgeneration
                              ? " (" + key.resize_hypervgeneration + ")"
                              : null}
                          </td>
                        ) : (
                          ""
                        )}
                        <td className="textfield">
                          {(() => {
                            console.log(
                              "Entitytype outside case: " +
                                this.state.entityType
                            );
                            switch (this.state.entityType) {
                              case "vm":
                                return (
                                  <Table>
                                    <tr>
                                      <td>
                                        <b>Num vCPU</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <b>CPU Speed</b>
                                      </td>
                                    </tr>
                                  </Table>
                                );
                                break;
                              case "asp":
                                return <b>CPU ACUs</b>;
                                break;
                              case "db":
                                return <b>Num vCore</b>;
                                break;
                            }
                          })()}
                        </td>
                        <td className="textfield">
                          {(() => {
                            switch (this.state.entityType) {
                              case "vm":
                                return (
                                  <Table>
                                    <tr>
                                      <td>{key.current_vcpu}</td>
                                    </tr>
                                    <tr>
                                      <td>{key.current_speed}</td>
                                    </tr>
                                  </Table>
                                );
                                break;
                              case "asp":
                                return key.current_speed;
                                break;
                              case "db":
                                return key.current_vcpu;
                                break;
                            }
                          })()}
                        </td>
                        <td className="textfield">
                          {(() => {
                            switch (this.state.entityType) {
                              case "vm":
                                return (
                                  <Table>
                                    <tr>
                                      <td>{key.recommended_vcpu}</td>
                                    </tr>
                                    <tr>
                                      <td>{key.recommended_speed}</td>
                                    </tr>
                                  </Table>
                                );
                                break;
                              case "asp":
                                return key.recommended_speed;
                                break;
                              case "db":
                                return key.recommended_vcpu;
                                break;
                            }
                          })()}
                        </td>
                        {i === 0 ? (
                          <td
                            className="textfield"
                            rowSpan={
                              data.vm.length *
                              (this.state.isAsp ||
                              this.state.entityType === "db"
                                ? 4
                                : 3)
                            }
                          >
                            {priceDisplay(
                              key.current_vm_price,
                              data.userCurrency
                            )}
                            /mo
                          </td>
                        ) : (
                          ""
                        )}
                        {i === 0 ? (
                          <td
                            className="textfield"
                            rowSpan={
                              data.vm.length *
                              (this.state.isAsp ||
                              this.state.entityType === "db"
                                ? 4
                                : 3)
                            }
                          >
                            {priceDisplay(
                              key.recommended_vm_price,
                              data.userCurrency
                            )}
                            /mo
                          </td>
                        ) : (
                          ""
                        )}
                      </tr>
                    );
                  })}

                  {this.state.entityType === "db"
                    ? data.osdisk.map((key, i) => {
                        return (
                          <tr>
                            {i === 0 ? (
                              <td rowSpan={data.osdisk.length}>
                                <div className="DbOsClass"></div>
                                <Col className="tableLeftHead">MEMORY</Col>
                              </td>
                            ) : (
                              ""
                            )}
                            <td className="textfield">
                              <Table>
                                <tr>
                                  <td>
                                    <b>Size</b>
                                  </td>
                                </tr>
                              </Table>
                            </td>
                            <td className="textfield">
                              <Table>
                                <tr>
                                  <td>{key.current_os_disk_memory} GiB</td>
                                </tr>
                              </Table>
                            </td>
                            <td className="textfield">
                              <Table>
                                <tr>
                                  <td>{key.recommended_os_disk_memory} GiB</td>
                                </tr>
                              </Table>
                            </td>
                          </tr>
                        );
                      })
                    : null}

                  {data.vm.map((key, i) => {
                    return (
                      <tr>
                        {i === 0 ? (
                          <td rowSpan={data.vm.length}>
                            <div
                              className={
                                this.state.entityType === "db"
                                  ? "DbMemoryClass"
                                  : "MemoryClass"
                              }
                            ></div>
                            <Col className="tableLeftHead">
                              {this.state.entityType === "db"
                                ? "DATA DISK"
                                : "MEMORY"}
                            </Col>
                          </td>
                        ) : (
                          ""
                        )}
                        <td className="textfield">
                          <b>
                            {this.state.entityType === "db" ? "IOPS" : "Size"}
                          </b>
                        </td>
                        <td className="numberfield">
                          {" "}
                          {parseFloat(key.current_memory).toFixed(2)}{" "}
                          {ProviderUtils.memoryUnits(this.state.providerName)}
                        </td>
                        <td className="textfield">
                          {" "}
                          {parseFloat(key.recommended_memory).toFixed(2)}{" "}
                          {ProviderUtils.memoryUnits(this.state.providerName)}
                        </td>
                      </tr>
                    );
                  })}
                  {data.vm.map((key, i) => {
                    return (
                      <tr>
                        {i === 0 ? (
                          <td rowSpan={data.vm.length}>
                            <div
                              className={
                                this.state.entityType === "db"
                                  ? "DbNetworkClass"
                                  : "NetworkClass"
                              }
                            ></div>
                            <Col className="tableLeftHead">
                              {this.state.entityType === "db"
                                ? "LOG DISK"
                                : "NETWORK"}
                            </Col>
                          </td>
                        ) : (
                          ""
                        )}
                        <td className="textfield">
                          <b>
                            {this.state.entityType === "db"
                              ? "Log Rate"
                              : "Bandwidth"}
                          </b>
                        </td>
                        <td className="textfield">
                          {key.current_network_bandwidth}
                        </td>
                        <td className="textfield">
                          {key.recommended_network_bandwidth}
                        </td>
                      </tr>
                    );
                  })}
                  {this.state.entityType !== "db"
                    ? data.osdisk.map((key, i) => {
                        return (
                          <tr>
                            {i === 0 ? (
                              <td rowSpan={data.osdisk.length}>
                                <div className="OsClass"></div>
                                <Col className="tableLeftHead">
                                  {this.state.isAsp ? "STORAGE" : "OS Disk"}
                                </Col>
                              </td>
                            ) : (
                              ""
                            )}
                            {this.state.isAsp ? (
                              ""
                            ) : i === 0 ? (
                              <td
                                className="textfield"
                                rowSpan={data.osdisk.length}
                              >
                                {key.current_os_disk_name.toUpperCase()}
                                {<br />}({key.current_os_disk_tier})
                              </td>
                            ) : (
                              ""
                            )}
                            {this.state.isAsp ? (
                              ""
                            ) : (
                              <td className="textfield">
                                {key.recommended_os_disk_name.toUpperCase()}
                                {<br />}({key.recommended_os_disk_tier})
                              </td>
                            )}
                            <td className="textfield">
                              {this.state.isAsp ? (
                                <b>Size</b>
                              ) : (
                                <Table>
                                  <tr>
                                    <td>
                                      <b>Throughput</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <b>IOPS</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <b>Size</b>
                                    </td>
                                  </tr>
                                </Table>
                              )}
                            </td>
                            <td className="textfield">
                              {this.state.isAsp ? (
                                key.current_os_disk_memory
                              ) : (
                                <Table>
                                  <tr>
                                    <td>{key.current_os_disk_bandwidth}</td>
                                  </tr>
                                  <tr>
                                    <td>{key.current_os_disk_iops}</td>
                                  </tr>
                                  <tr>
                                    <td>{key.current_os_disk_memory}</td>
                                  </tr>
                                </Table>
                              )}
                            </td>
                            <td className="textfield">
                              {this.state.isAsp ? (
                                key.recommended_os_disk_memory
                              ) : (
                                <Table>
                                  <tr>
                                    <td>{key.recommended_os_disk_bandwidth}</td>
                                  </tr>
                                  <tr>
                                    <td>{key.recommended_os_disk_iops}</td>
                                  </tr>
                                  <tr>
                                    <td>{key.recommended_os_disk_memory}</td>
                                  </tr>
                                </Table>
                              )}
                            </td>
                            {this.state.isAsp ? (
                              ""
                            ) : (
                              <td className="textfield">
                                {priceDisplay(
                                  key.current_os_disk_price,
                                  data.userCurrency
                                )}
                                /mo
                              </td>
                            )}
                            {this.state.isAsp ? (
                              ""
                            ) : (
                              <td className="textfield">
                                {priceDisplay(
                                  key.recommended_os_disk_price,
                                  data.userCurrency
                                )}
                                /mo
                              </td>
                            )}
                          </tr>
                        );
                      })
                    : null}
                  {this.state.entityType !== "db"
                    ? Object.keys(data.dataDisk).map((key) => {
                        return (
                          key <= 1 &&
                          data.dataDisk[key].map((value, i) => {
                            return (
                              <tr>
                                {i === 0 ? (
                                  <td
                                    className="textfield"
                                    rowSpan={data.dataDisk[key].length}
                                  >
                                    <div className="OsClass" />
                                    <Col className="tableLeftHead">
                                      DISK {key}
                                    </Col>
                                  </td>
                                ) : (
                                  ""
                                )}
                                <td className="textfield">
                                  {value.current_data_disk_name.toUpperCase()}
                                  {<br />}({value.current_data_disk_tier})
                                </td>
                                <td className="textfield">
                                  {value.recommended_data_disk_name.toUpperCase()}{" "}
                                  {<br />}({value.recommended_data_disk_tier})
                                </td>
                                <td className="textfield">
                                  <Table>
                                    <tr>
                                      <td>
                                        <b>Throughput</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <b>IOPS</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <b>Size</b>
                                      </td>
                                    </tr>
                                  </Table>
                                </td>
                                <td className="textfield">
                                  <Table>
                                    <tr>
                                      <td>
                                        {value.current_data_disk_bandwidth}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>{value.current_data_disk_iops}</td>
                                    </tr>
                                    <tr>
                                      <td>{value.current_data_disk_memory}</td>
                                    </tr>
                                  </Table>
                                </td>
                                <td className="textfield">
                                  <Table>
                                    <tr>
                                      <td>
                                        {value.recommended_data_disk_bandwidth}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        {value.recommended_data_disk_iops}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        {value.recommended_data_disk_memory}
                                      </td>
                                    </tr>
                                  </Table>
                                </td>
                                <td className="textfield">
                                  {priceDisplay(
                                    value.current_data_disk_price,
                                    data.userCurrency
                                  )}
                                  /mo
                                </td>
                                <td className="textfield">
                                  {priceDisplay(
                                    value.recommended_data_disk_price,
                                    data.userCurrency
                                  )}
                                  /mo
                                </td>
                              </tr>
                            );
                          })
                        );
                      })
                    : null}
                </tbody>
              </Table>
              {this.state.entityType !== "db" &&
              Object.keys(data.dataDisk).length >= 2 ? (
                <Table
                  style={{ pageBreakBefore: "always", marginTop: "25px" }}
                  className="tableview "
                  id="tableSizing"
                  bordered
                >
                  <thead>
                    <tr>
                      <td style={{ borderTop: "0px", borderLeft: "0px" }}></td>
                      <th>Original Spec</th>
                      <th>GAI Recommended Spec</th>
                      <th colSpan="2">Original Limits</th>
                      <th>GAI Recommended Limits</th>
                      <th>Original Cost*</th>
                      <th>GAI Recommended Cost*</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.entityType !== "db"
                      ? Object.keys(data.dataDisk).map((key) => {
                          return (
                            key >= 2 &&
                            data.dataDisk[key].map((value, i) => {
                              return (
                                <tr>
                                  {i === 0 ? (
                                    <td
                                      className="textfield"
                                      rowSpan={data.dataDisk[key].length}
                                    >
                                      <div className="OsClass" />
                                      <Col className="tableLeftHead">
                                        DISK {key}
                                      </Col>
                                    </td>
                                  ) : (
                                    ""
                                  )}
                                  <td className="textfield">
                                    {value.current_data_disk_name.toUpperCase()}
                                    {<br />}({value.current_data_disk_tier})
                                  </td>
                                  <td className="textfield">
                                    {value.recommended_data_disk_name.toUpperCase()}{" "}
                                    {<br />}({value.recommended_data_disk_tier})
                                  </td>
                                  <td className="textfield">
                                    <Table>
                                      <tr>
                                        <td>
                                          <b>Throughput</b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <b>IOPS</b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <b>Size</b>
                                        </td>
                                      </tr>
                                    </Table>
                                  </td>
                                  <td className="textfield">
                                    <Table>
                                      <tr>
                                        <td>
                                          {value.current_data_disk_bandwidth}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>{value.current_data_disk_iops}</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          {value.current_data_disk_memory}
                                        </td>
                                      </tr>
                                    </Table>
                                  </td>
                                  <td className="textfield">
                                    <Table>
                                      <tr>
                                        <td>
                                          {
                                            value.recommended_data_disk_bandwidth
                                          }
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          {value.recommended_data_disk_iops}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          {value.recommended_data_disk_memory}
                                        </td>
                                      </tr>
                                    </Table>
                                  </td>
                                  <td className="textfield">
                                    {priceDisplay(
                                      value.current_data_disk_price,
                                      data.userCurrency
                                    )}
                                    /mo
                                  </td>
                                  <td className="textfield">
                                    {priceDisplay(
                                      value.recommended_data_disk_price,
                                      data.userCurrency
                                    )}
                                    /mo
                                  </td>
                                </tr>
                              );
                            })
                          );
                        })
                      : null}
                  </tbody>
                </Table>
              ) : null}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
export default ResizeGaiRecommendationTable;
